import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import SEO from '../components/seo/SEO';
import ProductGrid from '../components/products/ProductGrid';
import ProductGridSkeleton from '../components/products/ProductGridSkeleton';
import { getSaleProducts } from '../services/products';
import { useToast } from '../hooks/use-toast';
import { BRAND_NAME } from '../lib/brand';

const SalePage = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const saleProducts = await getSaleProducts();
        setProducts(saleProducts);
      } catch (error) {
        console.error('Error fetching sale products:', error);
        toast({
          title: 'Hata',
          description: 'Ürünler yüklenirken bir sorun oluştu. Lütfen sayfayı yenileyin.',
          variant: 'destructive',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [toast]);

  return (
    <Layout>
      <SEO
        title={`${BRAND_NAME} | İndirimli Ürünler`}
        description={`${BRAND_NAME} indirimli ürünler. %50'ye varan indirimlerle harika fırsatlar. Sınırlı süre!`}
      />
      <div className="w-full max-w-[1600px] mx-auto py-6 sm:py-8">
        <div className="mb-12 px-3 text-center sm:px-4 md:px-6 lg:px-8">
          <span className="mb-2 inline-block text-sm font-medium uppercase tracking-wider text-red-600">
            Sınırlı Süre
          </span>
          <h1 className="mb-4 text-4xl font-bold sm:text-5xl">İndirimli Ürünler</h1>
          <p className="mx-auto max-w-2xl text-gray-600">
            En iyi fırsatlarımızı keşfedin. Seçili ürünlerde %50'ye varan indirimler.
          </p>
        </div>

        {loading ? (
          <ProductGridSkeleton columns={4} count={12} />
        ) : products.length > 0 ? (
          <ProductGrid products={products} columns={4} />
        ) : (
          <div className="px-3 py-12 text-center sm:px-4">
            <p className="mb-4 text-lg text-gray-500">
              Şu anda indirimli ürün bulunmamaktadır.
            </p>
            <p className="text-gray-400">
              Yakında harika fırsatlar eklenecek, tekrar kontrol edin!
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default SalePage;